import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { DatePicker } from 'ant-design-vue';
import { colors } from '@/constants/theme/colors';
import { brandModels, brands } from '../constants/brandModels';
import './styles/compatibility-form.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompatibilityForm',
  props: {
    plate: null,
    caseNotFound: { type: Boolean }
  },
  emits: ['searchDetails'],
  setup(__props: any, { emit }) {

const props = __props as {
  plate?: string;
  caseNotFound?: boolean;
};



const plateValue = ref(props.plate || '');

const selectedBrand = ref<string | null>(null);
const selectedModel = ref<string | null>(null);

const models = computed(() => {
  if (!selectedBrand.value) return [];
  return brandModels[selectedBrand.value] || [];
});

const onBrandChange = () => {
  selectedModel.value = null;
};

const calibrationDate = ref<moment.Moment | null>(null);
const registrationDate = ref<moment.Moment | null>(null);
const calibrationPickerOpen = ref(false);
const registrationPickerOpen = ref(false);
const hasTachograph = ref(false);
const hasTransport = ref(false);



const handleCalibrationChange = (value: moment.Moment | null) => {
  calibrationDate.value = value;
  calibrationPickerOpen.value = false;
};

const handleRegistrationChange = (value: moment.Moment | null) => {
  registrationDate.value = value;
  registrationPickerOpen.value = false;
};

const searchByDetails = () => {
  emit('searchDetails', {
    licencePlateNumber: plateValue.value,
    brand: selectedBrand.value,
    model: selectedModel.value,
    registrationDate: registrationDate.value ? registrationDate.value.unix() : null,
    lastCalibration: calibrationDate.value ? calibrationDate.value.unix() : null,
    vdoTachographInstalled: hasTachograph.value,
    internationalTransport: hasTransport.value
  });

  // Reinit all fields
  plateValue.value = '';
  selectedBrand.value = null;
  selectedModel.value = null;
  registrationDate.value = null;
  calibrationDate.value = null;
  hasTachograph.value = false;
  hasTransport.value = false;
  calibrationPickerOpen.value = false;
  registrationPickerOpen.value = false;
};

// Licence plate and last calibration date are optional; only brand, model
// and registration date are required to run a details-based compatibility check.
const isFormValid = computed(() => !!(
  selectedBrand.value
    && selectedModel.value
    && registrationDate.value
));

return { __sfc: true,props, plateValue, selectedBrand, selectedModel, models, onBrandChange, calibrationDate, registrationDate, calibrationPickerOpen, registrationPickerOpen, hasTachograph, hasTransport, emit, handleCalibrationChange, handleRegistrationChange, searchByDetails, isFormValid, DatePicker, colors, brands }
}

})